import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  listActiveLoading: false,
  actionsLoading: false,
  entities: [],
  error: null
};

export const callTypes = {
  list: "list",
  listActive: "list",
  action: "action"
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;

      if (action.payload.error.response &&
        action.payload.error.response.data &&
        action.payload.error.response.data.message
      ) {
        state.error = action.payload.error.response.data.message;
      }

      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      }
      else if (action.payload.callType === callTypes.listActive) {
        state.listActiveLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.listActive) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    invoiceFetched: (state) => {
      state.listLoading = false;
      state.error = null;
    },
  }
});
